module.exports = __webpack_public_path__ + "img/Exclusive.236ad92d.jpg";